import { render, staticRenderFns } from "./VuesticColorInput.vue?vue&type=template&id=1d96f2ee&scoped=true"
import script from "./VuesticColorInput.vue?vue&type=script&lang=js"
export * from "./VuesticColorInput.vue?vue&type=script&lang=js"
import style0 from "./VuesticColorInput.vue?vue&type=style&index=0&id=1d96f2ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d96f2ee",
  null
  
)

export default component.exports